@import '../../../scss/global_v2_member_light-vars.css';

.button {
  width: 100%;
  background-color: var(--vip-brand-bttn-color-primary-brand-enabled);
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  font-family: var(--vip-brand-font-fam-buttons);
  color: var(--vip-core-color-neutral-900);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: none;
  cursor: pointer;
  transition: background-color 200ms ease;
  text-wrap: nowrap;

  &.rounded {
    border-radius: 9999px;
  }

  &:disabled {
    background-color: var(--vip-bttn-disabled-bg-pressed);
    color: var(--vip-bttn-disabled-fg-pressed, #8b8b8b);
    cursor: not-allowed;
  }

  &:not(:disabled) .icon-container {
    transition: transform 150ms ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:hover:not(:disabled) {
    background-color: var(--vip-brand-bttn-color-primary-brand-hover);

    .icon-container {
      transform: translateX(0.25rem);
    }
  }

  &.secondary {
    background: var(--bttn-secondary-bg-enabled, #ffdcb5);

    &:hover:not(:disabled) {
      background: var(--bttn-secondary-bg-hover, #ffc789);
    }
    &:active:not(:disabled) {
      background: var(--bttn-secondary-bg-pressed, #ffbd74);
    }
  }
}
